export function isOnlyWhitespaceOrNbsp(html: string): boolean {
  if (!html) return true

  const div = document.createElement('div')
  div.innerHTML = html

  const text = div.textContent || div.innerText || ''

  return text.trim().replace(/\u00A0/g, '').length === 0
}
